import React, { Fragment } from "react";
import { useIntl } from "react-intl";
import { _eventBus } from "../../../core/events/EventBus";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { useRecState } from "../../../Orchestrator/Recoils/Events/Recoil";
import {
  IPassengerSelection,
  SearchStateType,
} from "../../../Orchestrator/Types/Index";
import ItemContent from "./ItemContent";
import "./search-trip.css";
import Link from "next/link";
import { isInfantIncrementDisabled, isChildIncrementDisabled } from "../../../Lib/Utils/passengerValidation";

interface PassengerSelectorProps {
  passengerTypes: IPassengerSelection[];
  totalWithoutInfants: number;
  isFromPopUp?: boolean;
}

const PassengerSelector: React.FC<PassengerSelectorProps> = ({
  passengerTypes,
  totalWithoutInfants,
  isFromPopUp,
}) => {
  const intl = useIntl();
  const [search] = useRecState<SearchStateType>("searchStateAtom");
  const [searchPopupData] = useRecState<SearchStateType>(
    "searchStatePopupAtom"
  );

  const handlePassengerChange = async (type: string, value: number) => {
    await _eventBus.emit({
      eventName: evtTree.SearchBar.SelectPassenger.IncDecClick,
      data: { type, value, search, isFromPopUp, searchPopupData },
    });
  };

  const totalWheelChairs = search.passengers?.wheelchair || 0;

  // Show "addOneAdult" only when children or infants are present but no adult/senior has been selected.
  // Using isChildIncrementDisabled (adults+seniors === 0) avoids the old vacuous-true issue
  // where Object.values({}).every(...) fired on an empty form.
  const showMessage =
    isChildIncrementDisabled(search.passengers || {}) &&
    ((search.passengers?.children || 0) > 0 || (search.passengers?.infants || 0) > 0);

  const isIncrementDisabled = (type: IPassengerSelection) => {
    return (
      (type.id === "infants" && isInfantIncrementDisabled(search.passengers || {})) ||
      (type.id === "children" && isChildIncrementDisabled(search.passengers || {})) ||
      (totalWithoutInfants >= 9 && type.id !== "infants") ||
      (totalWheelChairs == 2 && type.id === "wheelchair")
    );
  };
  return (
    <div className="passenger-dropdown" dir={intl.locale === "ar" ? "rtl" : "ltr"}>
      {passengerTypes.map((type) => (
        <Fragment key={type.id}>
          <ItemContent
            type={type}
            currentCount={search.passengers?.[type.id] || 0}
            handlePassengerChange={handlePassengerChange}
            searchPassengers={search.passengers}
            isDecrementDisabled={
              search.passengers?.[type.id] === 0 ||
              search.passengers?.[type.id] === undefined
            }
            isIncrementDisabled={isIncrementDisabled(type)}
          />
        </Fragment>
      ))}

      <div className="total-passengers-limit">
        {showMessage && <p>{intl.formatMessage({ id: "addOneAdult" })}</p>}
        {totalWithoutInfants === 9 && (
          <p>{intl.formatMessage({ id: "totalPassengersLimit" })}</p>
        )}
        {isInfantIncrementDisabled(search.passengers || {}) && (search.passengers?.infants || 0) > 0 && (
          <p>{intl.formatMessage({ id: "infantNumberCannotExceed" })}</p>
        )}
        {totalWheelChairs === 2 && (
          <p>{intl.formatMessage({ id: "totalWheelchairLimit" })}</p>
        )}
      </div>

      <div className="book_9_passengers"><Link href="/group-booking" rel="noopener noreferrer" className="book_9_passengers_link ff-inter">{intl.formatMessage({ id: "Book9Passenger" })}</Link></div>
    </div>
  );
};

export default PassengerSelector;
